import React, {Component} from "react";
import {connect} from "react-redux";
import {Spin} from "antd";
import CategoriesContainer from "./CategoriesContainer";
import {DataTypes} from "../../data/types";
import {getCollection, loadingError, startLoading} from "../../data/actionCreators";
import {errorMessage} from "../../helpers/error";

const mapStateToProps = (dataStore) => ({
    ...dataStore
});

const mapDispatchToProps = dispatch => ({
    loadCollection: (dataType, params, history, onSuccess) => {
        dispatch(startLoading(dataType, 'Pobieranie danych'));
        dispatch(getCollection(dataType, params, onSuccess, (error) => {
            dispatch(loadingError(error));
            errorMessage(error, history);
        }));
    }
});

export const CategoriesConnector = connect(mapStateToProps, mapDispatchToProps)(
    class extends Component {

        componentDidMount = () => {
            this.props.loadCollection(DataTypes.CATEGORIES, this.props[`${DataTypes.CATEGORIES}_params`], this.props.history);
        }

        render() {
            return <Spin spinning={this.props.loading} tip={this.props.text}>
                <CategoriesContainer {...this.props}/>
            </Spin>
        }
    }
);
